import { render, staticRenderFns } from "./Categorization.vue?vue&type=template&id=0b5d732c&scoped=true&"
import script from "./Categorization.vue?vue&type=script&lang=js&"
export * from "./Categorization.vue?vue&type=script&lang=js&"
import style0 from "./Categorization.vue?vue&type=style&index=0&id=0b5d732c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5d732c",
  null
  
)

export default component.exports